module.exports = __webpack_public_path__ + "img/44400.a8fa7e6c.jpg";